import { render, staticRenderFns } from "./VoiceItem.vue?vue&type=template&id=debebcca&scoped=true"
import script from "./VoiceItem.vue?vue&type=script&lang=js"
export * from "./VoiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debebcca",
  null
  
)

export default component.exports